import type React from "react";
import { Outlet } from "react-router-dom";

import { AdminHeader } from "./components/AdminHeader/AdminHeader";

import { MainPageLayout } from "components/MainPageLayout";
import { AdminNavigationMenu } from "./components/AdminNavigationMenu/AdminNavigationMenu";

export const AdminPage: React.FC = () => (
  <MainPageLayout
    header={<AdminHeader />}
    navigationMenu={<AdminNavigationMenu />}
    shouldShowHeader={true}
    shouldShowSideNav={true}
  >
    <Outlet />
  </MainPageLayout>
);
